import { hero, heroHeight } from '../variables';

const animateHero = () => {
  const heroImage = hero.querySelector('.post-head-image-wrapper');

  requestAnimationFrame(() => {
    if (window.scrollY < heroHeight) {
      hero.style.zIndex = 'initial';
      hero.style.transform = `translate3d(0, -${window.scrollY / 2}px, 0)`;

      if (heroImage) {
        heroImage.style.transform = `translate3d(0, -${window.scrollY / 2}px, 0)`;
      }
    } else {
      hero.style.zIndex = '-100000';
    }
  });
};

const initHero = () => {
  const body = document.body;
  const isColoredHero = body.classList.contains('colored-hero');

  const heroScrollHandler = () => {
    if (window.scrollY === 0) {
      body.classList.add('colored-hero');
    } else if (window.scrollY > heroHeight) {
      body.classList.remove('colored-hero');
    }
  };

  if (isColoredHero) {
    heroScrollHandler();
    window.addEventListener('scroll', heroScrollHandler);
  }

  if (window.innerWidth >= 1000) {
    animateHero();
    window.addEventListener('scroll', animateHero);
  }
};

export { initHero };
